module.exports = __webpack_public_path__ + "img/bg_login-mobile.b0bbcb64.svg";